require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-archive-limewire-music-blog.json") })
        }
      }, "path---projects-archive-limewire-music-blog");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-archive-limewire-music-blog!./.cache/json/projects-archive-limewire-music-blog.json
// module id = 361
// module chunks = 231608221292675